import React from 'react';
export function LifestyleEaseSection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-white to-baby-blue-light" data-id="element-658">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-659">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center" data-id="element-660">
          {/* Image */}
          <div className="order-2 lg:order-1 animate-fade-in-up" data-id="element-661">
            <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow" data-id="element-662">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nX6TCCizYvCg97RpAB9gkh/8-mama_mirando_a_camara_con_el_bebe_e.png" alt="Mamá usando el celular mientras su bebé come - Facilidad y tranquilidad" className="w-full h-auto" data-id="element-663" />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 animate-fade-in-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-664">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-665">
              Tu Vida Real, Simplificada
            </h2>

            <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8" data-id="element-666">
              <div className="bg-white/90 backdrop-blur-baby p-5 sm:p-6 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft" data-id="element-667">
                <h3 className="font-bold text-lg sm:text-xl text-gray-900 mb-2" data-id="element-668">
                  Menos estrés en la cocina
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-669">
                  Ya no tienes que pensar qué cocinar. Solo abres el ebook y
                  eliges.
                </p>
              </div>

              <div className="bg-white/90 backdrop-blur-baby p-5 sm:p-6 rounded-baby-lg border-2 border-baby-pink-light shadow-baby-soft" data-id="element-670">
                <h3 className="font-bold text-lg sm:text-xl text-gray-900 mb-2" data-id="element-671">
                  Más seguridad con las texturas
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-672">
                  Cada receta te dice exactamente qué textura es segura para la
                  edad de tu bebé.
                </p>
              </div>

              <div className="bg-white/90 backdrop-blur-baby p-5 sm:p-6 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft" data-id="element-673">
                <h3 className="font-bold text-lg sm:text-xl text-gray-900 mb-2" data-id="element-674">
                  Ideas rápidas para cada día
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-675">
                  Consulta desde tu celular mientras cocinas. Sin
                  complicaciones.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-6 sm:p-8 rounded-baby-lg border-2 border-baby-lavender shadow-baby-glow" data-id="element-676">
              <p className="text-lg sm:text-xl font-bold text-gray-900 text-center" data-id="element-677">
                Diseñado para mamás ocupadas que quieren lo mejor para sus bebés
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}